import { useCart } from "../../../../state/cart";
import { getTracking } from "../../../../tracking";

export type AddToCartResponse =
    | {
          success: false;
          errors: string[];
      }
    | {
          success: true;
          errors: string[];
          cartItemsCount: number;
          cartLink: string;
          firstAdd: boolean;
      };

export function afterAddToCart(
    productId: number,
    newCartItemsCount: number,
    firstAdd: boolean
) {
    const cart = useCart();
    cart.updateCartCount(newCartItemsCount);
    if (firstAdd === true)
        getTracking().then((tracking) => {
            tracking.odendoTrackingService.trackAddToCart(productId.toString());
        });
}
